/**
 * 本地缓存Key
 */

// 管理员资料
export const ADMIN_INFO = 'adminInfo'

// WEB端布局配置
export const STORE_CONFIG = 'storeConfig_v2'
// 后台标签页
export const STORE_TAB_VIEW_CONFIG = 'storeTabViewConfig'
// 终端
export const STORE_TERMINAL = 'storeTerminal'

// 工作时间
export const WORKING_TIME = 'workingTime'

// 切换到手机端前的上次布局方式
export const BEFORE_RESIZE_LAYOUT = 'beforeResizeLayout'

// 会员资料
export const USER_INFO = 'userInfo'

// ba官网用户信息
export const BA_ACCOUNT = 'ba_account'
